module.exports = __webpack_public_path__ + "static/media/LabIcon.eefd7bc1.svg";